<script lang="js">

export default {
    name: "EmailCard",
    props: {    enabled: {
      type: Boolean,
      default: true,
    },  },
    methods: {}
};
</script>

<template>
  <div class="card border-0 shadow-sm">
    <div class="card-header bg-white border-bottom-0" style="font-size: small">
      <ul
        class="nav nav-pills mb-3 bg-body-secondary rounded-4 d-flex w-100"
        id="pills-tab"
        role="tablist"
      >
        <li class="nav-item flex-fill" role="presentation">
          <button
            class="nav-link active w-100 rounded-4"
            id="pills-home-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-home"
            type="button"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
          >
            Inbox
          </button>
        </li>
        <li class="nav-item flex-fill" role="presentation">
          <button
            class="nav-link w-100 rounded-4"
            id="pills-profile-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-profile"
            type="button"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
          >
            Sent
          </button>
        </li>
        <li class="nav-item flex-fill" role="presentation">
          <button
            class="nav-link w-100 rounded-4"
            id="pills-contact-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-contact"
            type="button"
            role="tab"
            aria-controls="pills-contact"
            aria-selected="false"
          >
            Starred
          </button>
        </li>
      </ul>
    </div>
    <div class="card-body pt-0 px-0">
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active overflow-auto"
          id="pills-home"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
          tabindex="0"
          style="max-height: 300px"
        >
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="n in 10" :key="n">
              <p class="placeholder-glow mb-1">
                <span class="placeholder col-12"></span>
              </p>
            </li>
          </ul>
        </div>
        <div
          class="tab-pane fade overflow-auto"
          id="pills-profile"
          role="tabpanel"
          aria-labelledby="pills-profile-tab"
          tabindex="0"
          style="max-height: 300px"
        >
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="n in 10" :key="n">
              <p class="placeholder-glow mb-1">
                <span class="placeholder col-12"></span>
              </p>
            </li>
          </ul>
        </div>
        <div
          class="tab-pane fade overflow-auto"
          id="pills-contact"
          role="tabpanel"
          aria-labelledby="pills-contact-tab"
          tabindex="0"
          style="max-height: 300px"
        >
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="n in 10" :key="n">
              <p class="placeholder-glow mb-1">
                <span class="placeholder col-12"></span>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      v-if="!enabled"
      class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3"
      style="z-index: 10; cursor: not-allowed"
    >
      <h5 class="text-white fw-bold">Not activated yet</h5>
    </div>
  </div>
</template>
<style scoped></style>
